import Accordion from "../../../components/accordion"
import Loading from "../../../components/loading"
import CardStatus from "../../../components/card-status";
import {eventTag} from "../../../services/utils";

export default function Trash({
                                listTrash,
                                updateTrash,
                                loadMore,
                                event = null,
                                callbackCardFinalized,
                              }) {
  const getDisplayKey = (item) => (item.postCreditId && item.isPostCredit) ? `${item.id}${item.postCreditId}` : `${item.id}`;

  return (
    <Accordion
      title={`Planejamentos excluídos`}
      titleLength={listTrash?.count || 0}
      forceHeightUpdate={updateTrash}
      handleClick={() => eventTag(
        event.name,
        event.category,
        event.action,
        "Planejamentos excluídos"
      )}
    >
      {listTrash.loading ? (
        <div className="wrapper-loading-small">
          <Loading small />
        </div>
      ) : null}

      {!!listTrash.count ? (
        listTrash?.results.map((item, k) => {
          const displayKey = getDisplayKey(item);

          return (
            <CardStatus
              key={displayKey}
              data={item}
              isFinished={item.isFinished}
              showDuplicate={false}
              event={event}
              isRemoved={true}
              callbackFinalized={(e) => callbackCardFinalized(e)}
            />
          )
        })
      ) : (
        <div className="list-trash" style={{ minHeight: "auto" }}>
          <div className="empty" style={{ padding: '15px 0 35px'}}>
            Nenhum resultado encontrado
          </div>
        </div>
      )}

      {!!listTrash?.next ? (
        <div className="more-planning" style={{ marginTop: "15px", marginBottom: "15px" }}>
          <button type="button" onClick={loadMore}>
            Carregar mais
          </button>
        </div>
      ) : ''}
    </Accordion>
  )
}